<template lang="pug">
  BarChart#my-steps-chart(
    :chart-data="chartData"
    :goalLine="stepGoal"
    @add-background-color="backgroundColor = $event"
    showLegend
  )
</template>

<script>
import { mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtTitle from "@@/WtTitle/WtTitle";
import BarChart from "@/charts/BarChart";
import DashboardChartFilters from "@@/Members/DashboardChartFilters";

export default {
  name: "StepsChart",

  components: {
    DashboardChartFilters,
    BarChart,
    WtTitle
  },

  mixins: [dateUtilityMixin],

  props: {
    daysInChart: {
      type: Number,
      default: 7
    },

    isProfile: {
      type: Boolean,
      default: false
    },

    memberUsername: {
      type: String,
      default: ""
    },

    stepData: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      backgroundColor: null
    };
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),

    stepGoal() {
      // don't show step goal for profile page
      if (this.isProfile) return null;
      // if program loaded use that data since the admin might want to see the changes reflected immediatley upon changes to settings
      if (
        this._.get(this.coreProgramMeta, "enforceStepGoal", false) ||
        this._.get(this.$auth.user(), "program.enforceStepGoal", false)
      ) {
        return this._.get(
          this.coreProgramMeta,
          "defaultStepGoal",
          this.$auth.user().program.defaultStepGoal
        );
      } else if (this._.has(this.member, "memberData.stepGoal")) {
        // use member object before $auth.user() to ensure if member changes settings that it's reflected immediatley
        return this.member.memberData.stepGoal;
      } else if (this._.has(this.$auth.user(), "memberData.stepGoal")) {
        return this.$auth.user().memberData.stepGoal;
      }
      return null;
    },

    chartData: {
      get() {
        const dateRange = [...Array(this.daysInChart)].map((_, index) => {
          const date = this.date(this.moment().subtract(index, "day"))
            .formatted;

          const defaultObj = {
            steps: 0,
            activities: 0,
            stepsAndActivities: 0,
            created: date
          };

          const entry = this._.find(this.stepData, { created: date });

          return entry === undefined ? defaultObj : entry;
        });

        const labels = dateRange
          .map(day => this.moment(day.created).format("MMM DD"))
          .reverse();
        const dataSteps = dateRange.map(day => day.steps).reverse();
        const dataActivities = dateRange.map(day => day.activities).reverse();

        const colors = this._app_chart_two_color;

        const datasets = [
          {
            label: "Steps",
            backgroundColor: colors.steps,
            barPercentage: 0.5,
            data: dataSteps
          }
        ];
        // Only Show Activities if the ActivityConverter is enabled.
        if (this.coreProgramMeta.converter) {
          datasets.push({
            label: "Activities ",
            backgroundColor: colors.activities,
            barPercentage: 0.5,
            data: dataActivities
          });
        }

        return { labels, datasets };
      },
      set(data) {
        return data;
      }
    }
  }
};
</script>

<style lang="sass" scoped></style>
